import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { Caption } from '@estee/elc-typography';
import { ErrorTextTheme } from '../theme/default-theme';

const ErrorMessage = styled.div`
    font-size: 14px;
    min-height: 20px;
    line-height: 20px;
    letter-spacing: 2px;
    margin-bottom: 8px;
    padding: 0 16px;
    text-align: left;

    [dir='rtl'] & {
        text-align: right;
    }
`;

const ErrorText = styled(Caption)`
    ${ErrorTextTheme};
`;

interface IFieldErrorProps {
    id?: string;
    errorMessage: string;
}

const FieldError = (props: IFieldErrorProps) => {
    const errorClassName = classnames('elc-input-error', 'js-error');

    return (
        <ErrorMessage
            id={props.id}
            className={errorClassName}
            aria-live="assertive"
            aria-atomic={true}
        >
            <ErrorText>{props.errorMessage}</ErrorText>
        </ErrorMessage>
    );
};

export { IFieldErrorProps, FieldError };
